import MypageSubscribeContainer from './MypageSubscribeContainer';
export default MypageSubscribeContainer;
